import { BehaviorSubject, isObservable, Observable, of } from 'rxjs';

function convertToBehaviorSubject<T>(observable: Observable<T>, initialValue: T): BehaviorSubject<T> {
  const subject = new BehaviorSubject<T>(initialValue);

  observable.subscribe(value => {
    subject.next(value);
  });

  return subject;
}

function convertToObservable<T>(subject: BehaviorSubject<T>): Observable<T> {
  return subject.asObservable();
}

function toObservableBool(value: boolean | Observable<boolean> | undefined): Observable<boolean> {
  if (isObservable(value)) return value;
  return of(!!value);
}

export const reactive = {
  convertToBehaviorSubject,
  convertToObservable,
  toObservableBool,
};
